import { HotelBookType } from "redmond";

export const HOTEL_PAYMENT_STEP_SUBTITLE = (
  hotelBookType: HotelBookType,
  canRedeemRewards: boolean
) => {
  if (canRedeemRewards) {
    return `You can use rewards and the payment method you add to ${
      hotelBookType === HotelBookType.PRICE_FREEZE_PURCHASE
        ? "freeze this price"
        : "book this trip"
    }.`;
  }
  return "Choose the payment method to book this trip.";
};

export const HOTEL_MOBILE_PAYMENT_STEP_SUBTITLE = (
  hotelBookType: HotelBookType,
  canRedeemRewards: boolean
) => {
  if (canRedeemRewards) {
    switch (hotelBookType) {
      case HotelBookType.PRICE_FREEZE_PURCHASE:
        return "You can use rewards and the payment method to freeze this price.";
      case HotelBookType.PRICE_FREEZE_EXERCISE:
      case HotelBookType.DEFAULT:
      default:
        return "Pay for your booking using rewards, on a Capital One credit card, or use a combination of both.";
    }
  }
  return "Pay for your booking using a Capital One credit card.";
};

export const HOTEL_PAYMENT_CARD_SUBTITLE_WITH_CREDITS_AND_OFFERS = (
  hotelBookType: HotelBookType,
  canRedeemRewards: boolean
) => {
  if (canRedeemRewards) {
    return `Combine your travel credits, a travel offer, rewards, and the payment method you add to ${
      hotelBookType === HotelBookType.PRICE_FREEZE_PURCHASE
        ? "freeze this price"
        : "book this trip"
    }.`;
  }
  return "Choose the payment method to book this trip.";
};
